<avla-modal
  [name]="modalName"
  [blockCloseModalOnClickOutside]="true"
  class="modal-generic"
  type="dinamyc"
  [icon]="{
    icon: 'close',
    class: 'material-symbols-rounded',
    type: 'class'
  }"
>
  <div class="avla_modal_section__body p-2 pb-0">
    <div class="content w-[362px]">
      <div class="flex title justify-center mb-6">
        <p class="text-center text-lg font-medium mt-9 text-light-blue">Cerrar sesión</p>
      </div>
      <div class="description info">
        <p class="mb-7 mt-4 mx-auto text-center text-[14px] font-light">
          ¿Estas segur@ que deseas salir?
        </p>

        <div class="flex flex-row justify-center gap-6 mt-6">
          <avla-button
            class="avla-btn-flat-label-sm"
            label="Cancelar"
            (click)="closeModal()"
            [theme]="'secondary'"
            [isFlat]="true"
          >
          </avla-button>
          <avla-button
            class="avla-btn-secondary avla-btn-flat-label-sm"
            label="Aceptar"
            (click)="closeSession()"
            [theme]="'secondary'"
            [isFlat]="true"
          >
          </avla-button>
        </div>
      </div>
    </div>
  </div>
</avla-modal>
